export default __webpack_public_path__ + "static/media/sch-over2.4f1c025b.svg";